import React from 'react';
import { CheckIcon } from 'lucide-react';
import { ResolvedRequirement } from '../types/commission';
interface RequirementRowProps {
  requirement: ResolvedRequirement;
  onOpen?: (label: string) => void;
}

/** Promotion requirement with progress bar, styled for the dark tier/role cards. */
export function RequirementRow({
  requirement,
  onOpen
}: RequirementRowProps) {
  const percent = Math.min(100, Math.round(requirement.value / requirement.goal * 100));
  const met = requirement.value >= requirement.goal;
  const valueLabel = `${requirement.value}/${requirement.goal} ${requirement.suffix}`;
  const expandable = requirement.isExpandable && onOpen;
  return <div data-id="element-469" data-mp="308ml532b3kk1">
      <div className="flex items-center justify-between gap-3 text-sm" data-id="element-470" data-mp="308cudd9ft9da">
        <span className="flex items-center gap-2 text-brand-100" data-id="element-471" data-mp="30agwpqrou0bg">
          {met ? <CheckIcon className="h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-472" data-mp="359jzt5o3xwgs" /> : <span aria-hidden="true" className="h-4 w-4 shrink-0 rounded-full border border-brand-300" data-id="element-473" data-mp="39781qso7wpi6" />}
          {requirement.label}
        </span>
        {expandable ? <button type="button" onClick={() => onOpen(requirement.label)} aria-label={`${valueLabel} — view qualifying loans`} className="shrink-0 font-semibold tabular-nums text-white underline decoration-white/40 decoration-2 underline-offset-2 transition hover:decoration-gold-400" data-id="element-474" data-mp="3kbc44n4w5709">
            {valueLabel}
          </button> : <span className="shrink-0 font-semibold tabular-nums text-white" data-id="element-475" data-mp="6yiroq7fc95t">{valueLabel}</span>}
      </div>
      <div role="progressbar" aria-label={requirement.label} aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-white/15" data-id="element-476" data-mp="24xuh0dnnj7o">
        <div className={`h-full rounded-full ${met ? 'bg-gold-400' : 'bg-brand-400'}`} style={{
        width: `${percent}%`
      }} data-id="element-477" data-mp="pvk0km43mtf1" />
      </div>
    </div>;
}